import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { SlideToggleComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-include-archived-form-editor',
    standalone: true,
    templateUrl: './include-archived-form-editor.component.html',
    styleUrls: ['./include-archived-form-editor.component.scss'],
    providers: [createValueAccessorProvider(IncludeArchivedFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SlideToggleComponent]
})
export class IncludeArchivedFormEditorComponent extends FormEditorBase<boolean | undefined> {
    // Inputs as signals
    value = input<boolean | undefined>();
    readonly = input<boolean>(false);
    labelText = input<string>('Include Archived');

    // Internal state
    readonly checked = signal<boolean>(false);

    constructor() {
        super();
    }

    onToggleChange(value: boolean): void {
        this.checked.set(value);
        const mapped = this.mapSelectedItemsToValue();
        this.onChange(mapped);
        this.onTouched();
        this.valueChange.set(mapped);
    }

    override writeValue(value: boolean | undefined): void {
        super.writeValue(value);
        this.checked.set(!!value);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): boolean | undefined {
        return this.checked() ? true : undefined;
    }

    protected override mapValueToSelectedItems(): any[] {
        return [];
    }
}
